// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__pOAbb","content":"LoadingAlert_content__1mY1u"};